import type { CharacterStateView } from '@/types/nf'

export type CharacterStateTab = 'current' | 'history'

export interface CharacterStateHistoryGroup {
  characterName: string
  states: CharacterStateView[]
}

export function getCharacterStateTabMode(tab: CharacterStateTab): 'current' | 'history' {
  return tab === 'history' ? 'history' : 'current'
}

export function groupCharacterStateHistory(states: CharacterStateView[]): CharacterStateHistoryGroup[] {
  const groups = new Map<string, CharacterStateView[]>()
  for (const state of states) {
    const items = groups.get(state.character_name) ?? []
    items.push(state)
    groups.set(state.character_name, items)
  }
  return Array.from(groups.entries())
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([characterName, items]) => ({
      characterName,
      states: [...items].sort((left, right) => left.chapter_no - right.chapter_no),
    }))
}

export function parsePendingForeshadows(value: string): string[] {
  if (!value.trim()) return []
  try {
    const parsed = JSON.parse(value) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
  } catch {
    return []
  }
}
